/* Shipping estimate: the next day in Toronto, Sunday skipped (Mon–Sat ship days). */
(function () {
  var WEEKDAYS = ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'];
  var PREFIX = 'Shipped';
  var FLAG =
    '<svg viewBox="0 0 9600 4800" aria-hidden="true"><path fill="#d52b1e" d="M0 0h2400l99 99h4602l99-99h2400v4800h-2400l-99-99h-4602l-99 99H0z"/>' +
    '<path fill="#fff" d="M2400 0h4800v4800h-4800zm2490 4430-45-863a95 95 0 0 1 111-98l859 151-116-320a65 65 0 0 1 20-73l941-762-212-99a65 65 0 0 1-34-79l186-572-542 115a65 65 0 0 1-73-38l-105-247-423 454a65 65 0 0 1-111-57l204-1052-327 189a65 65 0 0 1-91-27l-332-652-332 652a65 65 0 0 1-91 27l-327-189 204 1052a65 65 0 0 1-111 57l-423-454-105 247a65 65 0 0 1-73 38l-542-115 186 572a65 65 0 0 1-34 79l-212 99 941 762a65 65 0 0 1 20 73l-116 320 859-151a95 95 0 0 1 111 98l-45 863z"/></svg>';

  function torontoToday() {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    var get = function (t) { return Number(parts.find(function (p) { return p.type === t; }).value); };
    return new Date(get('year'), get('month') - 1, get('day'));
  }

  function shipDate() {
    var d = torontoToday();
    d.setDate(d.getDate() + 1);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }

  function render() {
    var d = shipDate();
    var text = PREFIX + ' ' + WEEKDAYS[d.getDay()] + ' ' + d.getDate() + '.';
    document.querySelectorAll('.hl-shipping').forEach(function (el) {
      var spans = el.querySelectorAll(':scope > span');
      var date = spans[1];
      var flag = el.querySelector('.hl-shipping__flag');
      if (date) { date.className = 'hl-shipping__date'; date.textContent = text; }
      if (flag) flag.innerHTML = FLAG + '<span><strong>Free</strong> shipping</span>';
      el.classList.add('hl-ready');
    });
  }

  /* Preview only: ?hl_stock_demo=3 shows how the limited-stock bar looks. */
  function stockDemo() {
    var n = Number(new URLSearchParams(location.search).get('hl_stock_demo'));
    if (!n || document.querySelector('.hl-stock')) return;
    var picker = document.querySelector('variant-selects');
    if (!picker) return;
    picker.insertAdjacentHTML('beforeend',
      '<div class="hl-stock" role="status"><span class="hl-stock__dot" aria-hidden="true"></span><span class="hl-stock__label">Limited stock</span> : Only ' + n + (n === 1 ? ' item' : ' items') + ' left!' +
      '<div class="hl-stock__track" aria-hidden="true"><div class="hl-stock__bar" style="width:' + Math.max(4, Math.round(n * 100 / 40)) + '%"></div></div></div>');
  }

  function init() { render(); stockDemo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
